import { useQuery } from 'react-query';
import { apiServiceRest } from 'services/api';

import { IHotel } from '../types';

export const URI = () => '/hotels';
export const GET_QUERY_KEY = () => 'get-hotels';

export const useGetHotels = () => {
  const [apiService] = apiServiceRest<IHotel[]>();

  return useQuery(GET_QUERY_KEY(), () => apiService.get(URI()));
};
export default useGetHotels;
